import { useSelector } from 'react-redux';
import { settingsSelector } from '../../selectors';

export const FRANCHISE_FINMODEL_URL = 'https://pyrus.com/form/2330041';

export function openFranchiseFinmodelForm() {
  const settings = useSelector(settingsSelector);

  return () => {
    const urlFranchise = (settings && settings.urlFranchiseForm) ? settings.urlFranchiseForm : FRANCHISE_FINMODEL_URL;
    window.open(urlFranchise, '_blank', 'noopener,noreferrer');
  };
}
